import news from '@/views/news'
import newsActions from '@/views/news/main'
import addEditNews from '@/views/news/main/views/add-edit'
import listNews from '@/views/news/main/views/list'
import viewNews from '@/views/news/main/views/view'
// import newsModal from '@/views/news/modal'

const routes = [
	{
		path: '/comunicacao',
		name: 'news',
		component: news,
		meta: {
			title: 'Comunicação',
			protect: true
		},
		children: [
			{
				path: 'novidades',
				name: 'news.action',
				component: newsActions,
				meta: {
					title: 'Novidades',
					protect: true
				},
				redirect: { name: 'news.list' },
				children: [
					{
						path: 'listar/:category?',
						name: 'news.list',
						component: listNews,
						meta: {
							title: 'Novidades',
							subtitle: '',
							protect: true
						}
					},
					{
						path: 'editar/:id',
						name: 'news.edit',
						component: addEditNews,
						meta: {
							title: 'Novidades',
							subtitle: 'Editar Novidades',
							protect: true,
							permissions: {
								groups: ['broker', 'manager', 'supervisor'],
								redirect: '/comunicacao/novidades/listar'
							}
						}
					},
					{
						path: 'adicionar',
						name: 'news.add',
						component: addEditNews,
						meta: {
							title: 'Novidades',
							subtitle: 'Adicionar Novidades',
							protect: true,
							permissions: {
								groups: ['broker', 'manager', 'supervisor'],
								redirect: '/comunicacao/novidades/listar'
							}
						}
					},
					{
						path: ':id',
						name: 'news.view',
						component: viewNews,
						meta: {
							title: 'Novidade',
							subtitle: 'Leitura',
							protect: true
						},
					},
					// {
					// 	path: 'news/:infos?',
					// 	name: 'news.modal',
					// 	component: newsModal,
					// 	props: true,
					// 	meta: {
					// 		iframe: true,
					// 		title: (storage.get('client_name') || 'Facilita') + ' - Perfil',
					// 		protect: true
					// 	},
					// }
				],
			},
		],
	},
]

export { routes }

